import type { HealthNode } from '../types';

export type HealthFilter = 'all' | 'problems' | 'outdated';

export interface HealthFilterState {
  filter: HealthFilter;
  query: string;
}

// The version sidecar reads "v1.2.3 (gitsha)"; nodes report "v1.2.3".
const bareVersion = (v: string) => (v.includes(' (') ? v.slice(0, v.indexOf(' (')) : v).trim();

export const isOutdated = (node: HealthNode, latest: string): boolean => {
  const target = bareVersion(latest || '');
  if (!target || target === 'unknown' || !node.agent_version) return false;
  return node.agent_version !== target;
};

export const filterHealthNodes = (nodes: readonly HealthNode[], state: HealthFilterState, latest: string): HealthNode[] => {
  const query = state.query.trim().toLowerCase();
  return nodes.filter((n) => {
    if (state.filter === 'problems' && n.level === 'ok') return false;
    if (state.filter === 'outdated' && !isOutdated(n, latest)) return false;
    if (!query) return true;
    return [n.name, n.provider ?? '', n.region ?? ''].some((field) => field.toLowerCase().includes(query));
  });
};
